import axios from '../axios'
import { checkResponse, getProjectId } from '../utils'
import { apiV1, stringifyQuery } from '../utils/constant'

/**
 * @function getOrganizations
 * @desc 获取组织列表
 * @param {Number} projectId 项目id
 * @returns {Object} 返回组织列表信息
 */
function getOrganizations () {
  return axios
    .get(`${apiV1}/projects/${getProjectId()}/organizations`)
    .then(checkResponse)
}
/**
 * @function getOrganizationPages
 * @desc 按分页方式获取组织列表
 * @param {Number} page 页数
 * @param {Number} per 每页条数
 */
function getOrganizationPages (page = 1, per = 10) {
  return axios
  .get(
    `${apiV1}/projects/${getProjectId()}/organizations?datetime_format=datetime&page=${page}&per=${per}`
  )
  .then(checkResponse)
}

/**
 * @function getOrganizationLists 获取组织数据
 * @returns {Array}  organizationList
 */
const getOrganizationLists = () => {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/organizations?as=select`)
    .then(checkResponse)
}

/**
 * @function getOrganizationsTree
 * @desc 获取组织树
 * @param {Number} projectId 项目id
 * @returns {Object} 返回组织列表信息
 */
function getOrganizationsTree (params) {
  return axios
    .get(`${apiV1}/projects/${getProjectId()}/organizations/to_tree${stringifyQuery(params)}`)
    .then(checkResponse)
}
/**
 * @function getUcaseOrganizeCount
 * @desc 获取郑州组织案件数量
 * @param {Number} projectId 项目id
 * @returns {Object} 返回郑州组织案件数量
 */
 function getUcaseOrganizeCount () {
  return axios
    .get(`${apiV1}/projects/${getProjectId()}/ucases/zhengzhou_org_ucase_count`)
    .then(checkResponse)
}

/**
 * @function newOrganizations
 * @desc 新建组织
 * @param {Number} projectId 项目id
 * @param {String} organizations 组织名称
 * @param {boolean} add_user 默认是否添加用户
 * @returns {Object} 返回组织成功信息
 */
function newOrganizations (id, data) {
  return axios
    .post(
      `${apiV1}/projects/${getProjectId()}/organizations/${id}/bulk_insert`,
      data
    )
    .then(checkResponse)
}
/**
 * @function edtiOrganizations
 * @desc 编辑组织
 * @param {Number} projectId 项目id
 * @param {Number} id 组织id
 * @param {String} name 组织名称
 * @returns {Object} 返回组织成功信息
 */
function edtiOrganizations (id, data) {
  return axios
    .put(`${apiV1}/projects/${getProjectId()}/organizations/${id}`, {
      data,
    })
    .then(checkResponse)
}
/**
 * @function delOrganizations
 * @desc 删除组织
 * @param {Number} projectId 项目id
 * @param {Number} node_id 组织id
 * @returns {Object} 返回组织成功信息
 */
function delOrganizations (id) {
  return axios
    .delete(`${apiV1}/projects/${getProjectId()}/organizations/${id}`)
    .then(checkResponse)
}

/**
 * @function getResponsibilitySubject
 * @desc 获取责任主体
 * @param {Number} projectId 项目id
 * @returns {Object} 返回责任主体列表
 */
function getResponsibilitySubject () {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/organizations?slug=resorg&leaf=true`)
    .then(checkResponse)
}

function getResponsibility () {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/organizations?slug=resorg`)
    .then(checkResponse)
}
/**
 * @function getBusorySubject
 * @desc 获取业务科室
 * @param {Number} projectId 项目id
 * @returns {Object} 返回责任主体列表
 */
function getBusorySubject () {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/organizations?slug=busorg&leaf=true`)
    .then(checkResponse)
}
function getBusory () {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/organizations?slug=busorg`)
    .then(checkResponse)
}
function getBusorgAndResorg () {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/organizations?slug[]=busorg&slug[]=resorg`)
    .then(checkResponse)
}
export {
  getOrganizationPages,
  getOrganizations,
  getOrganizationsTree,
  getUcaseOrganizeCount,
  newOrganizations,
  edtiOrganizations,
  delOrganizations,
  getOrganizationLists,
  getResponsibilitySubject,
  getBusorySubject,
  getResponsibility,
  getBusory,
  getBusorgAndResorg
}

